import dayjs from 'dayjs';
const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);
const currentDate = dayjs().startOf('day').format('YYYY-MM-DD');
export default currentDate;
